import { render } from "./Formato.vue?vue&type=template&id=fa170842&scoped=true"
import script from "./Formato.vue?vue&type=script&lang=js"
export * from "./Formato.vue?vue&type=script&lang=js"

import "./Formato.vue?vue&type=style&index=0&id=fa170842&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa170842"]])

export default __exports__